"use client";
import ReviewCard from "./review_card";
import { useState } from "react";
import {
  BlockCustomerReview,
  BlockReviewsCard,
  ComponentVideoCard,
} from "@/types/schema";
import Typography from "@/components/common/typography";
import { Heading } from "@/components/common/typography/Heading";
import ClientCarousel, {
  CarouselItem,
} from "@/components/common/ui/ClientCarousel";

// Type definitions for the nested data structure
type NestedBlockReviewsCard = {
  id: number;
  item: BlockReviewsCard;
};

export type NestedVideoReviewsCard = {
  id: number;
  item: ComponentVideoCard;
};

const SeeTheResults = ({
  section_title,
  section_description,
  review_cards,
  review_videos,
}: BlockCustomerReview) => {
  const [reviewToggle, setReviewToggle] = useState(true);

  const reviewCards = review_cards as NestedBlockReviewsCard[];
  const reviewVideos = review_videos as NestedVideoReviewsCard[];

  return (
    <>
      <section className="flex flex-col gap-70px contentContainer">
        {section_title || section_description ? (
          <header className="flex flex-col gap-5 max-w-736px">
            <Heading size="h2" as="h2">
              {section_title}
            </Heading>
            <Heading size="h6" as="p" className="text-copy-gray">
              {section_description}
            </Heading>
          </header>
        ) : null}

        <section className="flex flex-col gap-42px">
          <ToggleButtons
            reviewToggle={reviewToggle}
            setReviewToggle={setReviewToggle}
          />
        </section>
      </section>

      {/* Written Review Mode */}
      {reviewToggle && (
        <ClientCarousel shadow={true}>
          {reviewCards.map((data, idx) => (
            <CarouselItem shadowItem key={`card-item-${idx}`}>
              <ReviewCard videoMode={false} {...data.item} />
            </CarouselItem>
          ))}
        </ClientCarousel>
      )}

      {/* Video Review Mode */}
      {!reviewToggle && (
        <ClientCarousel>
          {reviewVideos.map((data, idx) => (
            <CarouselItem
              firstCard={idx === 0}
              edgeCase
              key={`card-item-${idx}`}
            >
              <ReviewCard videoMode={true} {...data.item} />
            </CarouselItem>
          ))}
        </ClientCarousel>
      )}
    </>
  );
};

const ToggleButtons = ({
  reviewToggle,
  setReviewToggle,
}: {
  reviewToggle: boolean;
  setReviewToggle: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div className="flex gap-4  mb-5 z-30 w-fit">
      <button
        className={` transition-all duration-300 ease-in-out w-fit h-fit py-2 sm:px-6 px-4 rounded-full cursor-pointer ${
          reviewToggle ? "bg-black text-white" : "bg-bgColor"
        } `}
        onClick={() => setReviewToggle(true)}
      >
        <Typography
          size="body1"
          as="h3"
          color={reviewToggle ? "white" : "black"}
        >
          Written Reviews
        </Typography>
      </button>
      <button
        className={` transition-all duration-300 ease-in-out w-fit h-fit py-2 sm:px-6 px-4 cursor-pointer rounded-full ${
          !reviewToggle ? "bg-black text-white" : "bg-bgColor"
        } `}
        onClick={() => setReviewToggle(false)}
      >
        <Typography
          size="body1"
          as="h3"
          color={!reviewToggle ? "white" : "black"}
        >
          Video Reviews
        </Typography>
      </button>
    </div>
  );
};

export default SeeTheResults;
